import { ActionContext } from 'vuex';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { AppSessionStoreDataModule } from './AppSessionStoreDataModule';
import { IGebruiker } from '@/model/IGebruiker';
import * as _ from 'lodash';
import { appGebruikerService } from '@/services/appGebruikerService';
import { VoorkeurenNotificaties } from '@/model/VoorkeurenNotificaties';

export class AppGebruikerDataModule extends AppSessionStoreDataModule<IGebruiker, IAppRootState> {
  private static initialData: IGebruiker = {
    email: undefined,
    telefoonnummer: undefined,
    voorkeurNotificaties: undefined
  };
  public namespaced = true;

  constructor() {
    super('gebruiker', Object.assign({}, AppGebruikerDataModule.initialData));
  }

  @TjipVuexAction
  private getGebruiker(ctx: ActionContext<IGebruiker, IAppRootState>, force = false): Promise<IGebruiker> {
    const data = _.omit(ctx.state, AppSessionStoreDataModule.metaKeys);
    if (force || _.isEqual(data, AppGebruikerDataModule.initialData)) {
      return appGebruikerService.getGebruiker(force).then((gebruiker: IGebruiker) => {
        ctx.commit('getGebruikerSucceeded', gebruiker);
        return ctx.state;
      });
    }
    return Promise.resolve(ctx.state);
  }

  @TjipVuexAction
  private updateEmail(ctx: ActionContext<IGebruiker, IAppRootState>, email: string): Promise<void> {
    return appGebruikerService.updateEmail(email).then(() => {
      // reload gebruiker
      // todo: we probably shouldn't reload but logout and let auth0 do it's verification dance
      // backend should get notified by auth0 when email is confirmed before the updated email is sent to Boss
      return ctx.dispatch('getGebruiker', true).then();
    });
  }

  @TjipVuexAction
  private updateTelefoonnummer(ctx: ActionContext<IGebruiker, IAppRootState>, telefoonnummer: string): Promise<void> {
    return appGebruikerService.updateTelefoonnummer(telefoonnummer).then(() => {
      // reload gebruiker
      // todo: we probably shouldn't reload but logout and let auth0 do it's verification dance
      // backend should get notified by auth0 when telefoonnummer is confirmed before the updated telefoonnummer is sent to Boss
      return ctx.dispatch('getGebruiker', true).then();
    });
  }

  @TjipVuexAction
  private updateVoorkeurNotificaties(
    ctx: ActionContext<IGebruiker, IAppRootState>,
    voorkeurNotificaties: VoorkeurenNotificaties | undefined
  ): Promise<void> {
    return appGebruikerService.updateVoorkeurNotificaties(voorkeurNotificaties).then(() => {
      // reload gebruiker
      return ctx.dispatch('getGebruiker', true).then();
    });
  }

  @TjipVuexMutation
  private getGebruikerSucceeded(state: IGebruiker, value: IGebruiker) {
    Object.assign(state, AppGebruikerDataModule.initialData);
    Object.assign(state, value);
  }

  @TjipVuexAction
  protected logout(ctx: ActionContext<IGebruiker, IAppRootState>) {
    ctx.dispatch('reset');
  }
}
